/**
 * LanguageInitializer
 *
 * Client component that initializes language settings on page load
 * Used in unauthenticated layouts to ensure consistent language handling
 *
 * Primary responsibilities:
 * - Initialize language based on localStorage or browser settings
 * - No visible UI, just handles initialization
 *
 * Dependencies:
 * - useLanguage hook
 */

'use client'

import { useEffect } from 'react'
import { useLanguage } from '@/hooks/useLanguage'

export function LanguageInitializer() {
  // The useLanguage hook will handle initialization on mount
  const { isLoading } = useLanguage()

  // This component doesn't render anything visible
  // It just ensures the language hook is initialized
  return null
}
